module.exports = __webpack_public_path__ + "static/media/Whatsapp.1565f6c6.svg";